export function DwDataFromUSFHeadsUp(): JSX.Element {
  return (
    <div>
      <h2 className='mb-2'>Your Information from the University of South Florida</h2>
      <div className='textual-note mb-3'> {/* textual-note restores bullet points; do not omit it or bullet points will not show */}
        <p className="mb-3">
          After you complete and submit your onboarding form, the following information from the USF database will appear on your student profile.
          These values are pulled directly from USF records and cannot be modified through the Office of National Scholars website.
          If you believe any information is incorrect, please contact the appropriate USF office.
        </p>
        <ul className="ml-2">
            <li>Race</li>
            <li>Citizenship Status</li>
            <li>Gender</li>
            <li>Country, City, and State of Permanent Address</li>
            <li>Campus</li>
            <li>College</li>
            <li>Major(s)</li>
            <li>Minor(s)</li>
            <li>Academic Level (Undergraduate/Graduate)</li>
            <li>Academic Standing (Freshman/Sophomore/Junior/Senior)</li>
            <li>Undergraduate and/or Graduate GPA(s)</li>
            <li>First Semester at USF</li>
            <li>Whether you are a First-Time-In-College Student</li>
            <li>Whether you are an Athelete</li>
            <li>Whether you are a Veteran</li>
            <li>Whether you are in the Judy Genshaft Honors College</li>
            <li>Whether you are a Financial Aid Student</li>
            <li>Federal Work Study Program (FWSP) Amount Awarded and Received</li>
        </ul>
      </div>
    </div>
  )
}
